// The ContentIQ project rail — one definition shared by the wizard's rail,
// the Home strip and the Start page's "Continue to …" buttons, so a step
// can't go by two names (Edward's usability pass, 2026-10-22: the Start page
// said "Buyer map" where the rail said "Buyer map & output").
//
// The four phases of a content project (Edward's framing, settled
// 2026-10-08): 1 Gathering — deciding what to do, information in;
// 2 Content — research → options → strategy → the copy, ready to hand off;
// 3 Page build — the build team builds, the PM checks (starts only when the
// PM sends the copy); 4 Approve & launch — the package to the client, then
// live. EVERY project shows the same phases and the same steps — a step a
// project skips is greyed with a badge, never hidden (Edward's rule).
// Logos & brand and Final copy moved INTO Page build (Edward, 2026-10-22:
// brand is out of context while gathering assets, and the page copy is just
// "what the build team receives") — old ?section=brand / ?section=copy links
// land on Page build.
export const RAIL = [
  ['scope', 'Program & component', 'gather'],
  ['product', 'DemandArc product', 'gather'],
  ['assets', 'Client assets', 'gather'],
  ['questions', 'Questions & privacy', 'gather'],
  ['context', 'Company & campaign', 'gather'],
  ['review', 'Content plan', 'content'],
  ['research', 'Research', 'content'],
  ['personas', 'Buyer map & output', 'content'],
  ['strategy', 'Content strategy', 'content'],
  // 'Telequal script' left the rail (Edward, 2026-10-15) — scripts fold into
  // the strategy document under the three-lane model (R2); a separate nav
  // destination for them only confused the checkpoint. Panel + endpoints
  // remain for R2 to rework.
  ['deploy', 'Page build', 'build'],
  ['launch', 'Approve & launch', 'launchg'],
  // The sales enablement deck (v1, 2026-10-23) — after the pages are built,
  // since it shows them; a product without a deck greys it out.
  ['deck', 'Sales deck', 'launchg'],
];
export const PHASES = [
  ['gather', 1, 'Gathering'],
  ['content', 2, 'Content'],
  ['build', 3, 'Page build'],
  ['launchg', 4, 'Approve & launch'],
];

// A rail section's on-screen name ('personas' → 'Buyer map & output').
export function railName(key) {
  return (RAIL.find(([k]) => k === key) || [])[1] || key;
}

// While the hand-off is an email (Edward, 2026-11-04) no page builds exist, so
// phase 3 follows the build document: ready, downloaded, sent. stamps is the
// deploy payload's build_doc; ready is "the strategy is approved, or the copy
// is final". The app-sent package keeps its own sub-steps.
export function buildDocRail({ stamps, ready, fmtDate }) {
  const sentAt = stamps?.sent_to_build_at;
  const downloaded = !!stamps?.downloaded_at || !!sentAt;
  let summary = 'once the copy is approved';
  if (sentAt) summary = `sent to the build team ${fmtDate(sentAt)}`;
  else if (downloaded) summary = 'downloaded — email it to the build team';
  else if (ready) summary = 'ready — download the build document';
  return {
    summary,
    done: !!sentAt,
    steps: [
      { key: 'deploy-prep', label: 'Page copy, brand & images', done: !!ready || downloaded },
      { key: 'deploy-doc', label: 'Download the build document', done: downloaded },
      { key: 'deploy-send', label: 'Email it to the build team', done: !!sentAt },
    ],
  };
}
